import { render, staticRenderFns } from "./MemberBenefits.vue?vue&type=template&id=282f3a30&scoped=true"
import script from "./MemberBenefits.vue?vue&type=script&lang=js"
export * from "./MemberBenefits.vue?vue&type=script&lang=js"
import style0 from "./MemberBenefits.vue?vue&type=style&index=0&id=282f3a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f3a30",
  null
  
)

export default component.exports